import { useTranslations as useNextIntlTranslations } from "next-intl"
import type { ReactNode } from "react"

type ClientTranslator = {
    (key: string, values?: Record<string, string | number | Date>): string
    rich: (
        key: string,
        values: Record<
            string,
            string | number | Date | ((chunks: ReactNode) => ReactNode)
        >
    ) => ReactNode
    raw: (key: string) => unknown
    has: (key: string) => boolean
}

export function useClientTranslations(
    namespace:
        | "navigation"
        | "theme"
        | "chat"
        | "language"
        | "common"
        | "tracking"
        | "auth"
        | "errors"
        | "wilson"
        | "ai"
        | "knowledge"
        | "settings"
        | "tasks"
        | "inbox"
        | "comms"
        | "documents"
        | "mobile"
        | "chatTabs"
        | "notifications"
        | "email"
        | "richTextEditor"
        | "toggles"
        | "inboxError"
        | "slackThreads"
        | "ui"
        | "search"
        | "sandbox"
        | "sms"
        | "desktop"
        | "desktop.phone"
        | "desktop.document"
        | "desktop.documentDetail"
        | "desktop.tables"
        | "desktop.explorer"
        | "desktop.explorer.categories"
        | "desktop.settings"
        | "desktop.errorBoundary"
        | "desktop.page"
        | "desktop.contextMenu"
        | "desktop.chatHome"
        | "desktop.chatHome.rail"
        | "desktop.chatHome.summary"
        | "desktop.setup"
        | "desktop.setup.flow"
        | "desktop.setup.start"
        | "desktop.setup.flow.wallet.native"
        | "desktop.setup.welcome"
        | "desktop.setup.sections"
        | "desktop.setup.categories"
        | "desktop.setup.sidebar"
        | "desktop.setup.about"
        | "desktop.setup.features"
        | "desktop.setup.apps"
        | "desktop.setup.gettingStartedCards"
        | "desktop.setup.checklist"
        | "desktop.setup.knowledge"
        | "desktop.knowledgeNotes"
        | "desktop.knowledgeSkills"
        | "desktop.knowledgeDocs"
        | "desktop.skillDetail"
        | "desktop.knowledgeAccess"
        | "desktop.reports"
        | "desktop.templates"
        | "desktop.templateDetail"
        | "desktop.freightDashboard"
        | "desktop.warehouseFlow"
        | "desktop.cartagePay"
        | "desktop.onboarding"
        | "desktop.dock"
        | "desktop.shelf"
        | "desktop.a11y"
        | "common.statuses"
        | "portal"
        | "pdf"
        | "admin"
        | "settings.nylasAuth"
        | "warehouseScheduling"
        | "coaching"
): ClientTranslator {
    return useNextIntlTranslations(namespace)
}
